import HttpClient from '../../../services/http-client';
import { IParametersResponse } from '../../../../model/apm/parameters/response/parameters-response';
import { IParametersUpdateRequest } from '../../../../model/apm/parameters/request/parameters-update-request';

const defaultPath = 'Parameters';

const get = async (): Promise<IParametersResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`
    }).then((response) => response.data);
};

const update = async (params: IParametersUpdateRequest): Promise<IParametersResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const ParametersAppService = { get, update };
export default ParametersAppService;
